import {Injectable, OnDestroy} from '@angular/core';
import {Client as StompClient, over as overStomp} from 'stompjs';
import * as SockJS from 'sockjs-client';
import {GlobalService} from '../global/global.service';
import {UserWsInfo} from './model/user-ws-info';
import {IssueChatUnreadWsStateService} from './issue-chat-unread-ws-state.service';
import {Permissions} from '../auth/permissions';
import {AuthStorage} from '../auth/auth-storage';
import {Module} from '../model/profile';
import {delay, retryWhen} from 'rxjs/operators';

const isWebview = require('is-ua-webview');

const UNREAD_COUNT_TOPIC = `/users/issue-chat/unread-count`;

const CONNECTION_TIMEOUT = 60000;
const RECONNECT_TIMEOUT = 60000;
const HEARTBEAT_EVERY_MINUTE = 1000 * 60;

@Injectable({
  providedIn: 'root'
})
export class IssueChatUnreadWebSocketService implements OnDestroy {

  private stompClient: StompClient;

  constructor(private globalService: GlobalService,
              private issueChatUnreadWsStateService: IssueChatUnreadWsStateService) {
  }

  public getUserAndConnect() {
    if (Permissions.hasModule(Module.SERVICES) && AuthStorage.isLoggedClientEmployee() && !isWebview(navigator.userAgent)) {
      this.disconnect();
      this.globalService.userIssueChatWsInfo().pipe(retryWhen(delay(RECONNECT_TIMEOUT))).subscribe(
        userInfo => this.connect(userInfo)
      );
    }
  }

  private connect(userInfo: UserWsInfo): void {
    const ws = new SockJS(userInfo.url, null, {timeout: CONNECTION_TIMEOUT});
    this.stompClient = overStomp(ws);
    this.stompClient.heartbeat.outgoing = HEARTBEAT_EVERY_MINUTE;
    this.stompClient.heartbeat.incoming = HEARTBEAT_EVERY_MINUTE;
    this.disableLogs();

    const headers = {
      employeeId: userInfo.employeeId,
      clientId: userInfo.clientId,
      token: userInfo.token,
      accountId: userInfo.accountId
    };

    const self = this;
    this.stompClient.connect(headers, function() {
      self.stompClient.subscribe(UNREAD_COUNT_TOPIC, (event) => {
        self.issueChatUnreadWsStateService.notifyCountByVehicle(JSON.parse(event.body));
      });
    }, this.errorCallBack);
  }

  public errorCallBack = () => {
    this.reconnect();
  }

  private reconnect() {
    setTimeout(() => this.getUserAndConnect(), RECONNECT_TIMEOUT);
  }

  private disableLogs() {
    this.stompClient.debug = () => {};
  }

  public disconnect(): void {
    if (this.stompClient) {
      this.stompClient.disconnect();
      this.stompClient = null;
    }
  }

  public ngOnDestroy(): void {
    this.disconnect();
  }
}
